import styled from 'styled-components';

export const $StockTableViewsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`;

export const $ViewSelector = styled.div`
  max-width: 20rem;
  min-width: 12rem;
`;

export const $ManageViewsButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #ccd2f9;
  border-radius: 4px;
  background: #fff;
  color: #5c616b;
  cursor: pointer;

  &:hover {
    border-color: #5a72ff;
    color: #5a72ff;
  }
`;

export const $ModalField = styled.div`
  margin-bottom: 1rem;
`;

export const $ModalLabel = styled.label`
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
`;

export const $ViewsManageList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const $ViewsManageItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.875rem;

  &:last-child {
    border-bottom: none;
  }
`;

export const $ViewsManageItemActions = styled.div`
  display: flex;
  gap: 0.35rem;
`;
